import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ActiveAgencies, ActiveAirlines, Agency_Branches, B2BActiveBranches } from '../Models/ActiveClasses';
import { CustomerCodes, ReportTypesAgency, ReportTypesUser, UrlRequest } from '../Models/AgencyMasterProperties';
import { AgencyRightsProperties, ReportAgencyRightsProperties, ReportUserRightsProperties } from '../Models/AgencyRightsProperties';
import { UserListProperties } from '../Models/UserListProperties';
import {
  LoginUserProperties, LoginUserRights, UserAdminControlRightsProperties,
  UserAgentRightsProperties, UserRightsDisabledProperties, UserRoles, UsersProperties, GetAllProvinceDistrictTehsilCityTown, District, Tehsil, Town, City,
  AssignedAirlinesForTicketIssueBaseData,
  UserTicketIssueRightsPCCs,
  OneGprops,
  OneGNDCprops,
  OneGGDSprops,
  IndNDCprops,
  LCCsprops
} from "../Models/UsersProperties";
import { AgencyService } from '../Services/Agency.service';
import { BranchService } from '../Services/branch.service';
import { UsersService } from "../Services/users.service";
import { AuthService } from "../Services/auth.service";
import { BackSystemAllList, BackSystemCompanyId, BackSystemOfficeProperties } from '../Models/BranchInformationProperties';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { NgSelectComponent } from '@ng-select/ng-select';
import { environment } from '../../environments/environment';
import { SupplierAccessCodeBaseData } from '../Models/SuppliersProperties';
import { SuppliersService } from '../Services/suppliers.service';
import { LocalStorage } from '@ng-idle/core';
declare var $;


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
/** Users component*/
export class UsersComponent {
  /** Users ctor */
  //constructor(private branchService: BranchService, private agencyService: AgencyService, private userService: UsersService, private router: Router, private authservice: AuthService) { }
    constructor(private branchService: BranchService, private agencyService: AgencyService, private userService: UsersService, private router: Router, private service: SuppliersService, private authservice: AuthService) { }
  userObj = new UsersProperties();
  rightDisable = new UserRightsDisabledProperties;
  administratorCheck = false;
  agentCheck = false;
  agencyCodeList$: Observable<Agency_Branches[]>;
  branchCodeList$: Observable<B2BActiveBranches[]>;
  usersList$: Observable<UserListProperties[]>;
  reportTypesAgency: ReportTypesAgency[] = [];
  reportTypesUser: ReportTypesUser[] = [];
  reportRights: ReportAgencyRightsProperties[] = [];
  reportUserRights: ReportUserRightsProperties[] = [];
  cbAdmin = false;
  agencybranchRights = new AgencyRightsProperties();
  userRight: boolean = false;
  accountRight: boolean = false;
  currencyRight: boolean = false;
  codes: CustomerCodes[] = [];
  backSystemAllList: BackSystemAllList[] = [];
  backSystemCompanyIds: BackSystemCompanyId[] = [];
  onChnageCode: CustomerCodes[] = [];
  backSystemCompanies: CompanyMasterProperties[] = [];
  backSystemCompaniesForAdminInfo: CompanyMasterProperties[] = [];
  backsystemOfficeProperties: BackSystemOfficeProperties[] = [];
  updatecalled: boolean = false;
  loaderVar: boolean = false;
  agencyAG01: string = "";
  userRoles: UserRoles[] = [];
  getAllProvinceDistrictTehsilCityTown = new GetAllProvinceDistrictTehsilCityTown();
  filteredTehsils: Tehsil[] = [];
  filteredCities: City[] = [];
  filteredTowns: Town[] = [];
  userRoleName: string = "";
  isEditMode: boolean = false;
  isSaving: boolean = false;
  operatingCountry: string = '';
  @ViewChild('CustCodes', { static: false }) custCode: NgSelectComponent;
  ngOnInit() {
    this.operatingCountry = environment.operatingCountry;
    this.agencyAG01 = localStorage.getItem("AgencyId");
    let userId = localStorage.getItem("UserListId");
    if (userId != null) {
      let u = Number(userId);
      if (u > 0) {
        this.updatecalled = true;
      }
    }
    this.getReportTypes();
    this.loadUserAgencies();
    this.loadBackSystemUsers();
   // this.GetBackSystemCompanies();
    this.checkUsersRight();
    this.checkProfileRight();
    this.checkAccountRight();
    this.checkCurrencyRight();
    this.GetUserRoleName();
    //this.LoadUserData();
    if (this.operatingCountry === 'Pakistan') {
      this.GetUserRoles();
      this.GetAllProvinceDistrictTehsilCityTownAndInit();
    } else {
      this.GetBackSystemCompaniesAndInit();
    }
    this.loadAirlinesData();
  }
  //GetBackSystemCompanies() {
  //  this.agencyService.GetCompanyMaster().subscribe(data => {
  //    this.backSystemCompanies = data;
  //  })

  //}
  GetUserRoles() {
    let userId = Number(localStorage.getItem("UserId"));
    this.userService.GetAllUserRoles(userId).subscribe(data => {
      this.userRoles = data;
    })

  }
  ngOnDestroy() {
    localStorage.removeItem("UserListId");
    localStorage.removeItem("AgencyListId");
  }
  //GetAllProvinceDistrictTehsilCityTown() {
  //  this.userService.GetAllProvinceDistrictTehsilCityTown().subscribe(data => {
  //    this.getAllProvinceDistrictTehsilCityTown = data;
  //  })
  //}
  GetAllProvinceDistrictTehsilCityTownAndInit() {
    this.userService.GetAllProvinceDistrictTehsilCityTown().subscribe(data => {
      this.getAllProvinceDistrictTehsilCityTown = data;

      this.GetBackSystemCompaniesAndInit();
    });
  }
  GetBackSystemCompaniesAndInit() {
    this.agencyService.GetCompanyMaster().subscribe(data => {
      this.backSystemCompanies = data;

      // ✅ NOW safe to load user
      this.LoadUserData();
    });
  }
  ChangeGetSelectedTehsils(districtId: number) {
    if (!districtId) {
      this.filteredTehsils = [];
      this.userObj.tehsilId = null;
      return;
    }

    this.filteredTehsils = this.getAllProvinceDistrictTehsilCityTown.tehsils
      .filter(t => t.districtId === districtId);

    // Reset tehsil if previously selected and not valid now
    if (!this.filteredTehsils.some(t => t.tehsilId === this.userObj.tehsilId)) {
      this.userObj.tehsilId = null;
    }
  }
  ChangeGetSelectedCities(tehsilId: number) {
    if (!tehsilId) {
      this.filteredCities = [];
      this.userObj.cityId = null;
      this.filteredTowns = [];
      return;
    }

    this.filteredCities = this.getAllProvinceDistrictTehsilCityTown.cities
      .filter(c => c.tehsilId === tehsilId);

    // Reset invalid city
    if (!this.filteredCities.some(c => c.cityId === this.userObj.cityId)) {
      this.userObj.cityId = null;
    }
  }
  ChangeGetSelectedTowns(cityId: number) {
    if (!cityId) {
      this.filteredTowns = [];
      this.userObj.townId = null;
      return;
    }

    this.filteredTowns = this.getAllProvinceDistrictTehsilCityTown.towns
      .filter(t => t.cityId === cityId);

    // Reset invalid town
    if (!this.filteredTowns.some(t => t.townId === this.userObj.townId)) {
      this.userObj.townId = null;
    }
  }

  getReportTypes() {
    this.agencyService.GetAllReportTypes().subscribe((data) => {
      this.reportTypesAgency = data;
      let array = [];
      array = data;
      this.reportTypesUser = JSON.parse(JSON.stringify(array));
    })
  }

  GetUserRoleName() {
    let userId = Number(localStorage.getItem("UserId"));
    this.agencyService.GetUserRoleName(userId).subscribe((data) => {
      this.userRoleName = data;
      console.log(data);
      console.log(this.userRoleName);
    })
  }
  loadUserAgencies() {
    try {

      let agencyId = ""
      let userId = Number(localStorage.getItem("UserId"));
      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != "")) {
        agencyId = (localStorage.getItem("AgencyId"));
        this.userService.GetAgency_BranchByParent(agencyId).subscribe((data) => {
          this.agencyCodeList$ = of(data);
        })

      }
    }
    catch (e) {

    }
  }

  loadBackSystemUsers() {
    try {
      this.userService.GetAllUsers("Admin").subscribe((data) => {
        if (data != undefined && data != null) {
          this.usersList$ = of(data);
        }
      });
    }
    catch (e) {

    }
  }
  GetparentAgencyRights(agency_branchId) {
    try {

      if (agency_branchId != "" && agency_branchId != null && agency_branchId != undefined) {
        this.backsystemgetinfo(this.userObj.agency_branchId);
        
        this.userService.GetparentAgencyRights(agency_branchId, this.userObj.userId).subscribe((data) => {
          let rightsObj = new AgencyRightsProperties;
          this.rightDisable = new UserRightsDisabledProperties();
          rightsObj = (data);
          this.agencybranchRights = rightsObj;
          if (rightsObj != null) {
            this.reportRights = data.reportRights;
            if (this.reportRights != null) {
              for (let i = 0; i < this.reportRights.length; i++) {
                for (let j = 0; j < this.reportTypesUser.length; j++) {
                  if (this.reportTypesUser[j].reportTypes == this.reportRights[i].reportTypeName) {
                    this.reportTypesUser[j].statusForUser = this.reportRights[i].status;

                  }

                }
              }
            }
            if (rightsObj.reportUserRights != null) {
              for (let i = 0; i < rightsObj.reportUserRights.length; i++) {

                for (let j = 0; j < this.reportTypesUser.length; j++) {
                  if (this.reportTypesUser[j].reportTypes == rightsObj.reportUserRights[i].reportTypeName) {

                    this.reportTypesUser[j].reportRightId = rightsObj.reportUserRights[i].reportAgencyRightId;
                    this.reportTypesUser[j].status = rightsObj.reportUserRights[i].status;

                  }

                }
              }
            }
            if (rightsObj.currency == false) {
              this.rightDisable.ad_currencyDisabled = true;
            }

            if (rightsObj.profileUpdate == false) {
              this.rightDisable.ad_profileDisbled = true;
            }
            if (rightsObj.beneficiaryAccount == false) {
              this.rightDisable.ad_beneficiaryDisabled = true;
            }
            if (rightsObj.paymentProcess == false) {
              this.rightDisable.ad_paymentProcessDisabled = true;
            }
            if (rightsObj.creditLimit == false) {
              this.rightDisable.ad_creditLimitDisabled = true;
            }
            if (rightsObj.notifications == false) {
              this.rightDisable.ad_notificationsDisabled = true;
            }
            if (rightsObj.revenueManagement == false) {
              this.rightDisable.ad_revenueDisabled = true;
            }
            if (rightsObj.offlineRequest == false) {
              this.rightDisable.ad_offlineRequestDisabled = true;
            }
            if (rightsObj.offlineSettings == false) {
              this.rightDisable.ad_offlineSettingsDisabled = true;
            }
            if (rightsObj.supplierManagement == false) {
              this.rightDisable.ad_supplierManagementDisabled = true;
            }
            if (rightsObj.accountManagement == false) {
              this.rightDisable.ad_accountManagementDisabled = true;
            }
            if (rightsObj.bookings == false) {
              this.rightDisable.ad_bookingsDisabled = true;
            }
            if (rightsObj.cms == false) {
              this.rightDisable.ad_cmsDisabled = true;
            }
            if (rightsObj.reports == false) {
              this.rightDisable.ad_reportsDisabled = true;
            }
            if (rightsObj.dashboard == false) {
              this.rightDisable.ad_dashboardDisabled = true;
            }
            if (rightsObj.addPayment == false) {
              this.rightDisable.ad_addPaymentDisabled = true;
            }
            if (rightsObj.approvePayment == false) {
              this.rightDisable.ad_approvePaymentDisabled = true;
            }
            if (rightsObj.deletePayment == false) {
              this.rightDisable.ad_deletePaymentDisabled = true;
            }
            if (rightsObj.account == false) {
              this.rightDisable.ad_accountDisabled = true;
            }
            if (rightsObj.users == false) {
              this.rightDisable.ad_usersDisabled = true;
            }
            if (rightsObj.logs == false) {
              this.rightDisable.ad_logsDisabled = true;
            }
            if (rightsObj.currency == false) {
              this.rightDisable.ad_currencyDisabled = true;
            }
            if (rightsObj.searchBookings == false) {
              this.rightDisable.ad_searchBookingsDisabled = true;
            }
            if (rightsObj.viewBookings == false) {
              this.rightDisable.ad_viewBookingsDisabled = true;
            }
            if (rightsObj.updateBookings == false) {
              this.rightDisable.ad_updateBookingsDisabled = true;
            }
            if (rightsObj.fareRulesResult == false) {
              this.rightDisable.ag_fareRules_ResultDisabled = true;
            }
            if (rightsObj.quotations == false) {
              this.rightDisable.ag_quotationsDisabled = true;
            }

            if (rightsObj.issueTicket == false) {
              this.rightDisable.ag_issueTicketDisabled = true;
            }

            if (rightsObj.cancelPNR == false) {
              this.rightDisable.ag_cancelPNRDisabled = true;
            }

            if (rightsObj.refund == false) {
              this.rightDisable.ag_refundDisabled = true;
            }

            if (rightsObj.importPNR == false) {
              this.rightDisable.ag_importPNR = true;
            }
            if (rightsObj.exchange == false) {
              this.rightDisable.ag_exchangeDisabled = true;
            }
            if (rightsObj.voidTicket == false) {
              this.rightDisable.ag_voidTicketDisabled = true;
            }
            if (rightsObj.viewSubAgentBookings == false) {
              this.rightDisable.ag_viewSubAgentBooking = true;
            }
            if (rightsObj.reportsManagement == false) {
              this.rightDisable.ag_reportsManage = true;
            }
          }

        })
      }
    }
    catch (e) { }
  }


  UserRoleAdministrator(event) {
    if (event.target.checked) {
      this.userObj.userRoleId = 1;
    }
    else {
      this.userObj.userRoleId = 0;
    }
  }

  UserRoleChange(event) {
    if (this.userObj.isAgencyAdmin == true) {
      this.userObj.isAgent = false;
      if (this.userObj.agency_branchId.includes("B")) {
        this.userObj.isBranchAdmin = true;
        this.userObj.userRoleId = 1;
      }
      else {
        this.userObj.isAgencyAdmin = true;
        this.userObj.userRoleId = 1;
      }
    }
    else {
      this.userObj.isBranchAdmin = false;
      this.userObj.isAgencyAdmin = false;
      this.userObj.userRoleId = 0;
    }
    this.loadRightsChange();
  }

  UserRoleChangeAgent(event) {


    if (this.userObj.isAgent == true) {
      this.userObj.userRoleId = 2;
      this.cbAdmin = false;
      this.userObj.isAgencyAdmin = false;
      this.userObj.isBranchAdmin = false;
      this.loadRightsChange();
    }

  }

  AdministratorCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.userObj.adminUser.profileUpdate = true;
        this.userObj.adminUser.beneficiaryAccount = true;
        this.userObj.adminUser.paymentProcess = true;
        this.userObj.adminUser.creditLimit = true;
        this.userObj.adminUser.notifications = true;
        this.userObj.adminUser.revenueManagement = true;
        this.userObj.adminUser.offlineRequest = true;
        this.userObj.adminUser.offlineSettings = true;
        this.userObj.adminUser.supplierManagement = true;
        this.userObj.adminUser.accountManagement = true;
        this.userObj.adminUser.bookings = true;
        this.userObj.adminUser.cms = true;
        this.userObj.adminUser.isRegisterBecomePartnerList = true;
        this.userObj.adminUser.reports = true;
        this.userObj.adminUser.dashboard = true;
        this.userObj.adminUser.reportsManage = true;
      }
      else {
        this.userObj.adminUser.profileUpdate = false;
        this.userObj.adminUser.beneficiaryAccount = false;
        this.userObj.adminUser.paymentProcess = false;
        this.userObj.adminUser.creditLimit = false;
        this.userObj.adminUser.notifications = false;
        this.userObj.adminUser.revenueManagement = false;
        this.userObj.adminUser.offlineRequest = false;
        this.userObj.adminUser.offlineSettings = false;
        this.userObj.adminUser.supplierManagement = false;
        this.userObj.adminUser.accountManagement = false;
        this.userObj.adminUser.bookings = false;
        this.userObj.adminUser.cms = false;
        this.userObj.adminUser.isRegisterBecomePartnerList = false;
        this.userObj.adminUser.reports = false;
        this.userObj.adminUser.dashboard = false;
        this.userObj.adminUser.reportsManage = false;
      }

    }
    catch (e) {
    }
  }

  PaymentCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.userObj.adminUser.addPayment = true;
        if (this.cbAdmin)
          this.userObj.adminUser.approvePayment = true;
        // this.userObj.adminUser.deletePayment = true;
      }
      else {
        this.userObj.adminUser.addPayment = false;
        this.userObj.adminUser.approvePayment = false;
        // this.userObj.adminUser.deletePayment = false;
      }
    }
    catch (e) {

    }
  }

  OfflineUserCheckboxChange(event) {
    try {

      if (event.target.checked) {
        this.userObj.adminUser.offlineBooking = true;
        this.userObj.adminUser.offlineTicket = true;
        this.userObj.adminUser.offlineRefund = true;
        this.userObj.adminUser.offlineVoid = true;
        this.userObj.adminUser.offlineDealsByCMS = true;

      } else {
        this.userObj.adminUser.offlineBooking = false;
        this.userObj.adminUser.offlineTicket = false;
        this.userObj.adminUser.offlineRefund = false;
        this.userObj.adminUser.offlineVoid = false;
        this.userObj.adminUser.offlineDealsByCMS = false;

      }

    } catch (e) { }
  }


  AccountCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.userObj.adminUser.account = true;
        this.userObj.adminUser.users = true;
        this.userObj.adminUser.logs = true;
        this.userObj.adminUser.currency = true;
        this.userObj.adminUser.agencyManagement = true;
        this.userObj.adminUser.branchManagement = true;
      }
      else {
        this.userObj.adminUser.account = false;
        this.userObj.adminUser.users = false;
        this.userObj.adminUser.logs = false;
        this.userObj.adminUser.currency = false;
        this.userObj.adminUser.agencyManagement = false;
        this.userObj.adminUser.branchManagement = false;
      }
    }
    catch (e) {

    }
  }

  BookingCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.userObj.adminUser.searchBookings = true;
        this.userObj.adminUser.viewBookings = true;
        this.userObj.adminUser.updateBookings = true;
        // this.branchObj.agencyRightObj.updateBookings = true;
        this.userObj.adminUser.viewSubAgentBookings = true;
        this.userObj.adminUser.issueTicket = true;
        this.userObj.adminUser.cancelPNR = true;
        this.userObj.adminUser.refund = true;
        this.userObj.adminUser.importPNR = true;
        this.userObj.adminUser.exchangeTicket = true;
        this.userObj.adminUser.quotations = true;
        this.userObj.adminUser.fareRules = true;
        this.userObj.adminUser.voidTicket = true;
      }
      else {
        this.userObj.adminUser.searchBookings = false;
        this.userObj.adminUser.viewBookings = false;
        this.userObj.adminUser.updateBookings = false;
        this.userObj.adminUser.viewSubAgentBookings = false;
        this.userObj.adminUser.issueTicket = false;
        this.userObj.adminUser.cancelPNR = false;
        this.userObj.adminUser.refund = false;
        this.userObj.adminUser.importPNR = false;
        this.userObj.adminUser.exchangeTicket = false;
        this.userObj.adminUser.quotations = false;
        this.userObj.adminUser.fareRules = false;
        this.userObj.adminUser.voidTicket = false;
      }
    }
    catch (e) {
    }
  }
  AgentCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.userObj.agentUser.book = true;
        this.userObj.agentUser.issueTicket = true;
        this.userObj.agentUser.issuePNR = true;
        this.userObj.agentUser.cancelTicket = true;
        this.userObj.agentUser.cancelPNR = true;
        this.userObj.agentUser.quotations = true;
        this.userObj.agentUser.voidTicket = true;
        this.userObj.agentUser.fareRules_Result = true;
        this.userObj.agentUser.offlineRequest = true;
        this.userObj.agentUser.offlineBooking = true;
        this.userObj.agentUser.reprice = true;
        this.userObj.agentUser.markup = true;
        this.userObj.agentUser.refund = true;
        this.userObj.agentUser.offlineRefund = true;
        this.userObj.agentUser.exchange = true;
        this.userObj.agentUser.calenderSearch = true;
        this.userObj.agentUser.recentSearch = true;
        this.userObj.agentUser.adminPanelLogin = true;
      }
      else {
        this.userObj.agentUser.book = false;
        this.userObj.agentUser.issueTicket = false;
        this.userObj.agentUser.issuePNR = false;
        this.userObj.agentUser.cancelTicket = false;
        this.userObj.agentUser.cancelPNR = false;
        this.userObj.agentUser.quotations = false;
        this.userObj.agentUser.voidTicket = false;
        this.userObj.agentUser.fareRules_Result = false;
        this.userObj.agentUser.offlineRequest = false;
        this.userObj.agentUser.offlineBooking = false;
        this.userObj.agentUser.reprice = false;
        this.userObj.agentUser.markup = false;
        this.userObj.agentUser.refund = false;
        this.userObj.agentUser.offlineRefund = false;
        this.userObj.agentUser.exchange = false;
        this.userObj.agentUser.calenderSearch = false;
        this.userObj.agentUser.recentSearch = false;
        this.userObj.agentUser.adminPanelLogin = false;
      }
    }
    catch (e) {

    }
  }
  AgentBookingCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.userObj.agentUser.newBookings = true;
        this.userObj.agentUser.myBookings = true;
        this.userObj.agentUser.searchBookings = true;
      }
      else {
        this.userObj.agentUser.newBookings = false;
        this.userObj.agentUser.myBookings = false;
        this.userObj.agentUser.searchBookings = false;
      }
    }
    catch (e) {

    }
  }

  CheckAdminValidations(): boolean {
    try {
      if (this.userObj.agency_branchId == "" || this.userObj.agency_branchId == null || this.userObj.title == "" || this.userObj.loginName == ""
        || this.userObj.firstName == "" || this.userObj.lastName == "" || this.userObj.loginName == "" || this.userObj.email == "" || this.userObj.mobile == ""
        || this.userObj.telephone == "" || this.userObj.designation == ""
        || this.userObj.backSystemCompanyId == 0 || this.userObj.backSystemCompanyId == undefined || this.userObj.backSystemCompanyId == null
        || this.userObj.backSystemCompanyCustomer == "" || this.userObj.backSystemCompanyCustomer == undefined || this.userObj.backSystemCompanyCustomer == null) {
        // this.stepFour = false;
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Please Enter Required Fields."
        $("#lblerrormsg").delay(5000).hide(10);
        return false;
      }

      if (!this.validateEmail(this.userObj.email)) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Email pattern must be followed"
        $("#lblerrormsg").delay(5000).hide(10);
        return false;
      }
      if (!this.validateMobileNumber(this.userObj.mobile)) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Mobile Number Must Start with +"
        $("#lblerrormsg").delay(5000).hide(10);
        return false;
      }
      if (!this.validateNumber(this.userObj.telephone)) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Telephone Field must contain numbers"
        $("#lblerrormsg").delay(5000).hide(10);
        return false;
      }
      else {
        // this.stepFour = true;
        return true;
      }
    }

    catch (e) {
      console.log(e);
    }
  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  validateMobileNumber(number) {
    // const regularExp = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
    const regularExp = /\+[0-9]+/;

    return regularExp.test(String(number));
  }

  validateNumber(number) {
    const regularExp = /[0-9]+/;
    return regularExp.test(String(number));
  }

  SaveRights() {
    if (this.isSaving) {
      return;
    }
    try {
      let param = "";
      let isAgency;
      let userId = 0;
      this.userTicketIssueRightsPCCs.oneG = this.oneG;
      this.userTicketIssueRightsPCCs.oneGGDS = this.oneGGDS;
      this.userTicketIssueRightsPCCs.oneGNDC = this.oneGNDC;
      this.userTicketIssueRightsPCCs.indNDC = this.indNDC;
      this.userTicketIssueRightsPCCs.lccs = this.lccs;
      this.userObj.userTicketIssueRightsPCCs = this.userTicketIssueRightsPCCs;
      if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
        userId = Number(localStorage.getItem("UserId"))
        if (userId != 0) {

          if (this.CheckAdminValidations()) {
            if (this.userObj.userId != null && this.userObj.userId != 0
              && this.userObj.userId != undefined) {
              this.userObj.modifyUser = userId;
              this.userObj.reportTypesRightsUser[0].requestStatus = true;
              this.userObj.reportTypesRightsUser = this.reportTypesUser;
              if (this.userEmailExist == true) {
                document.getElementById("lblEmailExist").innerHTML = "Email already exist.";
                $(document.getElementById("lblEmailExist")).show();
                $(document.getElementById("lblEmailExist")).delay(5000).hide(500);
                return;
              }
            
              this.isSaving = true;
              this.userService.UpdateUser(this.userObj).subscribe((data) => {
                if (data != null && data != undefined && data != false) {
                  this.userObj.reportTypesRightsUser[0].requestStatus = false;
                  this.fetchUserPermissions(localStorage.getItem("AgencyId"), localStorage.getItem("UserId").toString());
                  document.getElementById("succesmessage").style.visibility = "visible";
                  setTimeout(() => {
                    document.getElementById("succesmessage").style.visibility = "hidden";
                    this.router.navigateByUrl("/userList").then((navigated) => {
                      if (!navigated) {
                        this.isSaving = false;
                      }
                    });
                  }, 2000);

                }
                else {
                  this.isSaving = false;
                  document.getElementById("errormessage").style.visibility = "visible";
                  setTimeout(() => {
                    document.getElementById("errormessage").style.visibility = "hidden";

                  }, 3000);

                  return false;
                }

              }, (error) => {
                this.isSaving = false;
              })
            }
            else {
              if (this.userObj.agency_branchId.includes("B"))
                isAgency = false;
              else
                isAgency = true;
              param = this.userObj.agency_branchId;
              this.isSaving = true;
              this.userService.CheckUsersLimit(param, isAgency).subscribe((data) => {
                if (data != null && data != undefined) {
                  if (data == -1) {
                    this.isSaving = false;
                    $("#lblerrormsg").show();
                    document.getElementById("lblerrormsg").innerHTML = "Maximum User Limit Reached."
                    $("#lblerrormsg").delay(5000).hide(10);
                  }
                  else {
                    this.userObj.creationUser = userId;
                    this.userObj.adminUser.creationUser = userId;
                    this.userObj.agentUser.creationUser = userId;
                    if (this.userEmailExist == true) {
                      this.isSaving = false;
                      document.getElementById("lblEmailExist").innerHTML = "Email already exist.";
                      $(document.getElementById("lblEmailExist")).show();
                      $(document.getElementById("lblEmailExist")).delay(5000).hide(500);
                      return;
                    }
                    this.CheckLoginName((available) => {
                      if (available == false) {
                        this.isSaving = false;
                        return;
                      }
                      this.userObj.reportTypesRightsUser = this.reportTypesUser;
                      this.userService.CreateUser(this.userObj).subscribe((data) => {
                        if (data != 0 && data != null && data != undefined) {
                          this.fetchUserPermissions(localStorage.getItem("AgencyId"), localStorage.getItem("UserId").toString());
                          document.getElementById("succesmessage").style.visibility = "visible";
                          setTimeout(() => {
                            document.getElementById("succesmessage").style.visibility = "hidden";
                            this.router.navigateByUrl("/userList").then((navigated) => {
                              if (!navigated) {
                                this.isSaving = false;
                              }
                            });
                          }, 2000);

                        }
                        else {
                          this.isSaving = false;
                          document.getElementById("errormessage").style.visibility = "visible";
                          setTimeout(() => {
                            document.getElementById("errormessage").style.visibility = "hidden";

                          }, 3000);

                          return false;
                        }
                      }, (error) => {
                        this.isSaving = false;
                      })
                    });
                  }
                }
                else {
                  this.isSaving = false;
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                  $("#lblerrormsg").delay(5000).hide(10);
                }
              }, (error) => {
                this.isSaving = false;
              });
            }
          }
        }
      }
    }
    catch (e) {
      this.isSaving = false;
      console.log(e)
    }
  }
  private fetchUserPermissions(agencyId: string, userId: string) {
    this.userService.GetUsersNavMenu(agencyId, userId).subscribe({
      next: (data) => {
        this.authservice.setNavMenu(data);
        // Store insurance rights separately if needed
        localStorage.setItem("InsuranceRights", JSON.stringify({
          "issue": data.insuranceIssuanceRight,
          "view": data.insuranceBookedViewRight,
          "cancel": data.insuranceCancelRight
        }));
      },
      error: (error) => {
        console.error('Error fetching user permissions', error);
      }
    });
  }
  //01-feb-24
  userEmailExist: boolean;
  CheckEmail(e: any) {

    let email = e.target.value;
    if (!this.validateEmail(email)) {
      document.getElementById("lblEmailExist").innerHTML = "Email Pattern Must be Followed.";
      $(document.getElementById("lblEmailExist")).show();
      $(document.getElementById("lblEmailExist")).delay(1000).hide(500);
      return;
    }
    this.userService.EmailExist(email, this.userObj.userId).subscribe((data) => {
      if (data == true) {
        this.userEmailExist = true;
        document.getElementById("lblEmailExist").innerHTML = "Email already exist.";
        $(document.getElementById("lblEmailExist")).show();
        $(document.getElementById("lblEmailExist")).delay(5000).hide(500);


      }
      else {
        this.userEmailExist = false;
      }

    });
  }
  //end
  LoadUserData() {
    try {
      let userId;
      if ((localStorage.getItem("UserListId") != undefined) && (localStorage.getItem("UserListId") != null)) {
        userId = (localStorage.getItem("UserListId"));
        if (userId != 0) {
          this.isEditMode = true;
          this.userService.GetUserByID(userId).subscribe((data) => {
            if (data != undefined && data != null) {
              this.userObj = data;
              this.ChangeGetSelectedBackSystemCustomers(this.userObj.backSystemCompanyId);
              if (this.operatingCountry === "Pakistan") {
                this.onRoleChange(this.userObj.userRoleId);
                this.ChangeGetSelectedTehsils(this.userObj.districtId);
                this.ChangeGetSelectedCities(this.userObj.tehsilId);
              }
              this.reportTypesUser = data.reportTypesRightsUser;
              //console.log(this.reportTypesUser);
              this.reportUserRights = data.reportRightsUser;
              for (let i = 0; i < this.reportUserRights.length; i++) {

                for (let j = 0; j < this.reportTypesUser.length; j++) {
                  if (this.reportUserRights[i].reportTypeName == this.reportTypesUser[j].reportTypes) {
                    this.reportTypesUser[j].status = this.reportUserRights[i].status;
                    this.reportTypesUser[j].reportRightId = this.reportUserRights[i].reportAgencyRightId;

                  }

                }
              }
              if (this.userObj.isAgencyAdmin == true || this.userObj.isBranchAdmin == true)
                this.cbAdmin = true;
              else
                this.cbAdmin = false;
              this.GetparentAgencyRights(this.userObj.agency_branchId);
            }
          })
        }
        else {
          this.isEditMode = false;
        }
      }
      else {
        this.cbAdmin = true;
        this.GetparentAgencyRights(this.userObj.agency_branchId);

      }


    }
    catch (e) {

    }
  }
  getSelectedRoleName() {
    const selected = this.userRoles.find(
      r => r.userRoleId === this.userObj.userRoleId
    );
    return selected ? selected.roleName : '';
  }
  checkUsersRight() {
    this.userService.checkUsersUpdateRightAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      this.userRight = data;
      if (data) {
        $("#btnSave").removeAttr("disabled");
      }
      else {

        $("#btnSave").attr("disabled", "disabled");
      }
      //this.LoadUserData();
    });
  }
  checkProfileRight() {
    if (!this.userRight)
      $("#btnSave").removeAttr("disabled");

    // users h means button enable h
    this.userService.checkProfileRightAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      if (data) {

        $("#btnSave").removeAttr("disabled");
      }
      else {
        $("#btnSave").attr("disabled", "disabled");
      }
      // this.LoadUserData();
    });
  }
  checkAccountRight() {
    let userId;
    if (localStorage.getItem("UserListId") != undefined && localStorage.getItem("UserListId") != null)
      userId = localStorage.getItem("UserListId");
    else
      userId = localStorage.getItem("UserId");
    this.userService.checkAccountRightAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), userId).subscribe((data) => {
      if (data)
        this.accountRight = true;


    });
  }
  checkCurrencyRight() {
    let userId;
    if (localStorage.getItem("UserListId") != undefined && localStorage.getItem("UserListId") != null)
      userId = localStorage.getItem("UserListId");
    else
      userId = localStorage.getItem("UserId");
    this.userService.checkCurrencyRightAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), userId).subscribe((data) => {
      if (data)
        this.currencyRight = true;


    });
  }

  loadRightsChange() {
    this.userObj.adminUser.account = false;
    this.userObj.adminUser.accountManagement = false;
    this.userObj.adminUser.addPayment = false;
    this.userObj.adminUser.agencyManagement = false;
    this.userObj.adminUser.approvePayment = false;
    this.userObj.adminUser.beneficiaryAccount = false;
    this.userObj.adminUser.bookings = false;
    this.userObj.adminUser.branchManagement = false;
    this.userObj.adminUser.cancelPNR = false;
    this.userObj.adminUser.cms = false;
    this.userObj.adminUser.isRegisterBecomePartnerList = false;
    this.userObj.adminUser.creditLimit = false;
    this.userObj.adminUser.currency = false;
    this.userObj.adminUser.dashboard = false;
    this.userObj.adminUser.deletePayment = false;
    this.userObj.adminUser.exchangeTicket = false;
    this.userObj.adminUser.fareRules = false;
    this.userObj.adminUser.importPNR = false;
    this.userObj.adminUser.issueTicket = false;
    this.userObj.adminUser.logs = false;
    this.userObj.adminUser.notifications = false;
    this.userObj.adminUser.offlineBooking = false;
    this.userObj.adminUser.offlineDealsByCMS = false;
    this.userObj.adminUser.offlineRefund = false;
    this.userObj.adminUser.offlineRequest = false;
    this.userObj.adminUser.offlineSettings = false;
    this.userObj.adminUser.offlineTicket = false;
    this.userObj.adminUser.offlineVoid = false;
    this.userObj.adminUser.paymentProcess = false;
    this.userObj.adminUser.profileUpdate = false;
    this.userObj.adminUser.quotations = false;
    this.userObj.adminUser.refund = false;
    this.userObj.adminUser.reports = false;
    this.userObj.adminUser.searchBookings = false;
    this.userObj.adminUser.supplierManagement = false;
    this.userObj.adminUser.updateBookings = false;
    this.userObj.adminUser.users = false;
    this.userObj.adminUser.viewBookings = false;
    this.userObj.adminUser.viewSubAgentBookings = false;
    this.userObj.adminUser.voidTicket = false;
    this.userObj.adminUser.reportsManage = false;
    this.userObj.adminUser.offlineManage = false;
    this.userObj.adminUser.offlineManageBooking = false;
    this.userObj.adminUser.offlineManageRefund = false;
    this.userObj.adminUser.offlineManageResissue = false;
    this.userObj.adminUser.offlineManageTicket = false;
    this.userObj.adminUser.offlineManageVoid = false;
    this.userObj.adminUser.offlineResissue = false;
  }
  ReportsCheckboxChange(event) {
    try {
      if (event.target.checked) {
        for (let i = 0; i < this.reportTypesUser.length; i++) {
          this.reportTypesUser[i].status = true;
        }
      }
      else {
        for (let i = 0; i < this.reportTypesUser.length; i++) {
          this.reportTypesUser[i].status = false;
        }
      }
    }
    catch (e) {

    }
  }
  loginCheck: boolean;
  CheckLoginName(callback?: (available: boolean) => void) {
    if (this.userObj.loginName != "" && this.userObj.loginName != null && this.userObj.loginName != undefined) {
      this.userObj.loginName = this.userObj.loginName.trim();
      this.branchService.GetCheckLoginNameAvaliability(this.userObj.loginName).subscribe((data) => {
        if (data == false) {
          this.loginCheck = true;
        }
        else if (data == true) {
          document.getElementById("loginnamemessage").innerHTML = "Login Name already exsist choose another one";
          setTimeout(function () {
            document.getElementById("loginnamemessage").innerHTML = "";
          }
            , 6000);
          this.loginCheck = false;
        }
        if (callback) {
          callback(this.loginCheck);
        }
      }, (error) => {
        this.loginCheck = false;
        if (callback) {
          callback(false);
        }
      });
    }
    else if (callback) {
      callback(false);
    }
    return this.loginCheck;

  }

  RadioSettleMentCheck(e) {
    try {
      if (e.target.id == "radioAdministrator") {

        this.userObj.isAgent = false;
        if (this.userObj.agency_branchId.includes("B")) {
          this.userObj.isBranchAdmin = true;
          this.userObj.userRoleId = 1;
        }
        else {
          this.userObj.isAgencyAdmin = true;
          this.userObj.userRoleId = 1;
        }
      }
      else if (e.target.id == "radioAgent") {
        this.userObj.isAgencyAdmin = false;
        this.userObj.isAgent = true;
        this.userObj.userRoleId = 2
        this.loadRightsChange();
      }
    }
    catch (e) {

    }
  }
  onRoleChange(value: number) {
    const selectedRole = value;  // roleId = 1 or 2

    try {
      if (selectedRole == 1) {   // Administrator

        this.userObj.isAgent = false;

        if (this.userObj.agency_branchId.includes('B')) {
          this.userObj.isBranchAdmin = true;
          this.userObj.isAgencyAdmin = false;
        } else {
          this.userObj.isAgencyAdmin = true;
          this.userObj.isBranchAdmin = false;
        }
      }

      else if (selectedRole == 2) {  // Agent

        this.userObj.isAgencyAdmin = false;
        this.userObj.isBranchAdmin = false;
        this.userObj.isAgent = true;

        this.loadRightsChange();
      }
      else {
        this.userObj.isAgencyAdmin = false;
        this.userObj.isBranchAdmin = false;
        this.userObj.isAgent = false;
      }
    }
    catch (e) { }
  }

  offlinechangeuser() {
    if (this.userObj.adminUser.offlineRequest == false) {
      this.userObj.adminUser.offlineBooking = false;
      this.userObj.adminUser.offlineDealsByCMS = false;
      this.userObj.adminUser.offlineRefund = false;
      this.userObj.adminUser.offlineTicket = false;
      this.userObj.adminUser.offlineVoid = false;
      this.userObj.adminUser.offlineResissue = false;
    }


  }
  offlinechangeManageruser() {
    if (this.userObj.adminUser.offlineManage == false) {
      this.userObj.adminUser.offlineManage = false;
      this.userObj.adminUser.offlineManageBooking = false;
      this.userObj.adminUser.offlineManageRefund = false;
      this.userObj.adminUser.offlineManageResissue = false;
      this.userObj.adminUser.offlineManageTicket = false;
      this.userObj.adminUser.offlineManageVoid = false;
     
    }


  }
  accountchangeuser() {
    if (this.userObj.adminUser.accountManagement == false) {

      this.userObj.adminUser.agencyManagement = false;
      this.userObj.adminUser.branchManagement = false;
      this.userObj.adminUser.account = false;
      this.userObj.adminUser.users = false;
      this.userObj.adminUser.logs = false;
      this.userObj.adminUser.currency = false;
    }
  }
  bookchangeuser() {
    if (this.userObj.adminUser.bookings == false) {
      this.userObj.adminUser.searchBookings = false;
      this.userObj.adminUser.viewBookings = false;
      this.userObj.adminUser.viewSubAgentBookings = false;
      this.userObj.adminUser.issueTicket = false;
      this.userObj.adminUser.cancelPNR = false;
      this.userObj.adminUser.refund = false;
      this.userObj.adminUser.importPNR = false;
      this.userObj.adminUser.exchangeTicket = false;
      this.userObj.adminUser.quotations = false;
      this.userObj.adminUser.fareRules = false;
      this.userObj.adminUser.voidTicket = false;
    }

  }
  paymemtchangeuser() {
    if (this.userObj.adminUser.paymentProcess == false) {
      this.userObj.adminUser.addPayment = false;
      this.userObj.adminUser.approvePayment = false;
    }

  }
  reportschangeuser() {
    if (this.userObj.adminUser.reportsManage == false) {
      for (let o = 0; o < this.reportTypesUser.length; o++) {
        this.reportTypesUser[o].status = false;
      }
    }

  }
  backsystemgetinfo(agency: string) {
    this.agencyService.GetBackSystemByid(agency).subscribe((data) => {
      if (data.length > 0) {
        this.backSystemAllList = [];
        this.backSystemCompanyIds = []
        this.backSystemAllList = data;
        this.backSystemAllList.forEach((item, index: number) => {
          let back = new BackSystemOfficeProperties()
          back.backSystemCompanyId = item.backSystemCompanyId;
          back.agecnyBranchID = item.agecnyBranchID;
          if (item.backSystemCompanyId != 0 && item.backSystemCompanyId != null && item.backSystemCompanyId != undefined) {
            let companyURL = "";
            for (let i = 0; i < this.backSystemCompanies.length; i++) {
              if (item.backSystemCompanyId == this.backSystemCompanies[i].companyId) {
                companyURL = this.backSystemCompanies[i].companyURL;
                this.loaderVar = true;
                break;
              }

            }
            var req = new UrlRequest();
            req.request = companyURL;
            this.agencyService.GetCustomerCodeByID(req).subscribe((data) => {
              this.backsystemOfficeProperties[index].customerCodesList = data
              this.loaderVar = false;
            });
          }

          item.backSystemAll.forEach((c) => {
            back.backSystemCompanyCustomer.push(c.backSystemCompanyCustomer);
          });
          this.backsystemOfficeProperties.push(back);
          let companyName = new BackSystemCompanyId();
          companyName.backSystemCompanyId = item.backSystemCompanyId;
          this.backSystemCompanyIds.push(companyName);
        });

        this.backSystemCompaniesForAdminInfo = [];
        for (let i = 0; i < this.backSystemCompanyIds.length; i++) {
          for (let j = 0; j < this.backSystemCompanies.length; j++) {
            if (this.backSystemCompanies[j].companyId == this.backSystemCompanyIds[i].backSystemCompanyId) {
              let backSystem = new CompanyMasterProperties();
              backSystem.companyId = this.backSystemCompanies[j].companyId;
              backSystem.companyName = this.backSystemCompanies[j].companyName;
              this.backSystemCompaniesForAdminInfo.push(backSystem);
              break;
            }
          }
        }
        for (let j = 0; j < this.backSystemCompaniesForAdminInfo.length; j++) {
          if (this.backSystemCompaniesForAdminInfo[j].companyId == this.userObj.backSystemCompanyId) {
            this.GetSelectedBackSystemCustomers(this.userObj.backSystemCompanyId);
            break;
          }
        }

      }
    });
  }
  ChangeGetSelectedBackSystemCustomers(companyId: number){
    if(this.userObj.backSystemCompanyId!=0){
      this.loaderVar = true;
     // this.custCode.handleClearClick();
    }
    this.GetSelectedBackSystemCustomers(companyId);
  }
  GetSelectedBackSystemCustomers(companyId: number) {
    if (companyId != null && companyId != undefined && companyId > 0) {
      let companyURL = "";
      for (let i = 0; i < this.backSystemCompanies.length; i++) {
        if (companyId == this.backSystemCompanies[i].companyId) {
          companyURL = this.backSystemCompanies[i].companyURL;      
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.agencyService.GetCustomerCodeByID(req).subscribe((data) => {
        this.codes = data;
        this.loaderVar = false;
        this.onChnageCode = [];
        this.backSystemAllList
        for (let i = 0; i < this.backSystemAllList.length; i++) {
          if (this.backSystemAllList[i].backSystemCompanyId == companyId) {
            for (let j = 0; j < this.backSystemAllList[i].backSystemAll.length; j++) {
              for (let k = 0; k< this.codes.length; k++) {
                if (this.backSystemAllList[i].backSystemAll[j].backSystemCompanyCustomer == this.codes[k].customerCode) {                
                  this.onChnageCode.push(this.codes[k]);
                  break;
                }
              }
            }
            break;
          }
        }
      });
    }

  }




  ChangeApprovePayment = (event: any): void => {
    if (event.target.checked == false) {
      this.userObj.adminUser.approvePayment = false;
      this.userObj.adminUser.beneficiaryAccount = false;
    }
  }

  //10-June-24
  GroupTicketAdminRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.userObj.adminUser.groupTicketRight = false;
      this.userObj.adminUser.groupTicketListRight = false;
      this.userObj.adminUser.groupTicketCreateRight = false;
      this.userObj.adminUser.groupTicketShowRight = false;
    }
  }
  ResetUser() {

    

    this.userService.ResetUser(this.userObj.userId, Number(localStorage.getItem("UserId"))).subscribe((statusdata) => {
        if (statusdata != null && statusdata != false) {
          document.getElementById("succesmessage").style.visibility = "visible";
          setTimeout(() => {
            document.getElementById("succesmessage").style.visibility = "hidden";
            this.router.navigateByUrl("/userList")
          }, 2000);

        }
      });
  }
  //end
  showadminInfoPassowrd() {
    var x = document.getElementById("tbpassword") as HTMLInputElement;

    if (x.type === "password") {
      x.type = "text";
      document.getElementById("togglePassword").classList.toggle("fa-eye");
      document.getElementById("togglePassword").classList.remove("fa-eye-slash");
    } else {
      x.type = "password";
      document.getElementById("togglePassword").classList.add("fa-eye-slash");
      document.getElementById("togglePassword").classList.remove("fa-eye");
    }
  }
  airlines$: Observable<ActiveAirlines[]>;
  assignedAirlines$: UserTicketIssueRightsPCCs;

  loadAirlinesData() {
    try {
      this.userService.GetAssignedAndAllAirlinesForTicketIssueByID(localStorage.getItem("AgencyListId"), localStorage.getItem("UserListId")).subscribe((data: AssignedAirlinesForTicketIssueBaseData) => {
        this.assignedAirlines$ = data.userTicketIssueRightsPCCs;
        this.airlines$ = of(data.allAirlinesList);
        this.oneG.oneGRightStatus = this.assignedAirlines$.oneG.oneGRightStatus;
        this.oneG.oneG7KE2RightStatus = this.assignedAirlines$.oneG.oneG7KE2RightStatus;
        this.oneG.oneG84XHRightStatus = this.assignedAirlines$.oneG.oneG84XHRightStatus;
        this.oneG.oneG8X4IRightStatus = this.assignedAirlines$.oneG.oneG8X4IRightStatus;
        this.oneG.oneGB2DRightStatus = this.assignedAirlines$.oneG.oneGB2DRightStatus;
        this.oneG.oneG82QTRightStatus = this.assignedAirlines$.oneG.oneG82QTRightStatus;
        this.oneG.oneG8K5XRightStatus = this.assignedAirlines$.oneG.oneG8K5XRightStatus;

        this.oneGGDS.oneGGDSRightStatus = this.assignedAirlines$.oneGGDS.oneGGDSRightStatus;
        this.oneGGDS.oneGGDS8X4IRightStatus = this.assignedAirlines$.oneGGDS.oneGGDS8X4IRightStatus;
        this.oneGGDS.oneGGDS8K5XRightStatus = this.assignedAirlines$.oneGGDS.oneGGDS8K5XRightStatus;
        this.oneGGDS.oneGGDSB2DRightStatus = this.assignedAirlines$.oneGGDS.oneGGDSB2DRightStatus;
        this.oneGGDS.oneGGDS7KE2RightStatus = this.assignedAirlines$.oneGGDS.oneGGDS7KE2RightStatus;

        this.oneGNDC.oneGNDCRightStatus = this.assignedAirlines$.oneGNDC.oneGNDCRightStatus;
        this.oneGNDC.oneGNDC8X4IRightStatus = this.assignedAirlines$.oneGNDC.oneGNDC8X4IRightStatus;
        this.oneGNDC.oneGNDC8K5XRightStatus = this.assignedAirlines$.oneGNDC.oneGNDC8K5XRightStatus;
        this.oneGNDC.oneGNDCB2DRightStatus = this.assignedAirlines$.oneGNDC.oneGNDCB2DRightStatus;
        this.oneGNDC.oneGNDC7KE2RightStatus = this.assignedAirlines$.oneGNDC.oneGNDC7KE2RightStatus;

        this.indNDC.rightStatus = this.assignedAirlines$.indNDC.rightStatus;
        this.lccs.rightStatus = this.assignedAirlines$.lccs.rightStatus;

        this.oneG.assignedAirlines1G7KE2 = this.assignedAirlines$.oneG.assignedAirlines1G7KE2;
        this.oneG.assignedAirlines1G84XH = this.assignedAirlines$.oneG.assignedAirlines1G84XH;
        this.oneG.assignedAirlines1G8X4I = this.assignedAirlines$.oneG.assignedAirlines1G8X4I;
        this.oneG.assignedAirlines1GB2D = this.assignedAirlines$.oneG.assignedAirlines1GB2D;
        this.oneG.assignedAirlines1G82QT = this.assignedAirlines$.oneG.assignedAirlines1G82QT;
        this.oneG.assignedAirlines1G8K5X = this.assignedAirlines$.oneG.assignedAirlines1G8K5X;

        this.oneGGDS.assignedAirlinesGDS8X4I = this.assignedAirlines$.oneGGDS.assignedAirlinesGDS8X4I;
        this.oneGGDS.assignedAirlinesGDS8K5X = this.assignedAirlines$.oneGGDS.assignedAirlinesGDS8K5X;
        this.oneGGDS.assignedAirlinesGDSB2D = this.assignedAirlines$.oneGGDS.assignedAirlinesGDSB2D;
        this.oneGGDS.assignedAirlinesGDS7KE2 = this.assignedAirlines$.oneGGDS.assignedAirlinesGDS7KE2;

        this.oneGNDC.assignedAirlinesNDC8X4I = this.assignedAirlines$.oneGNDC.assignedAirlinesNDC8X4I;
        this.oneGNDC.assignedAirlinesNDC8K5X = this.assignedAirlines$.oneGNDC.assignedAirlinesNDC8K5X;
        this.oneGNDC.assignedAirlinesNDCB2D = this.assignedAirlines$.oneGNDC.assignedAirlinesNDCB2D;
        this.oneGNDC.assignedAirlinesNDC7KE2 = this.assignedAirlines$.oneGNDC.assignedAirlinesNDC7KE2;

        this.indNDC.assignedAirlines = this.assignedAirlines$.indNDC.assignedAirlines;
        this.lccs.assignedAirlines = this.assignedAirlines$.lccs.assignedAirlines;
      });
    } catch (ex) { }
  }
  update1GAssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneGRightStatus = status;
  }
  update1GGDSAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGGDS.oneGGDSRightStatus = status;
  }
  update1GNDCAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGNDC.oneGNDCRightStatus = status;
  }

  //1G7KE2, 1G84XH, 1G8X4I, 1GB2D, 1G82QT, 1G8K5X
  update1G7KE2AssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneG7KE2RightStatus = status;
  }
  update1G84XHAssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneG84XHRightStatus = status;
  }
  update1G8X4IAssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneG8X4IRightStatus = status;
  }
  update1GB2DAssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneGB2DRightStatus = status;
  }
  update1G82QTAssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneG82QTRightStatus = status;
  }
  update1G8K5XAssignedAirlinePCCVisibility(status: boolean) {
    this.oneG.oneG8K5XRightStatus = status;
  }

  //1GGDS8X4I, 1GGDS8K5X, 1GGDSB2D, 1GGDS7KE2
  update1GGDS7KE2AssignedAirlinePCCVisibility(status: boolean) {
    this.oneGGDS.oneGGDS7KE2RightStatus = status;
  }
  update1GGDS8X4IAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGGDS.oneGGDS8X4IRightStatus = status;
  }
  update1GGDSB2DAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGGDS.oneGGDSB2DRightStatus = status;
  }
  update1GGDS8K5XAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGGDS.oneGGDS8K5XRightStatus = status;
  }

  //1GNDC8X4I, 1GNDC8K5X, 1GNDCB2D, 1GNDC7KE2
  update1GNDC7KE2AssignedAirlinePCCVisibility(status: boolean) {
    this.oneGNDC.oneGNDC7KE2RightStatus = status;
  }
  update1GNDC8X4IAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGNDC.oneGNDC8X4IRightStatus = status;
  }
  update1GNDCB2DAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGNDC.oneGNDCB2DRightStatus = status;
  }
  update1GNDC8K5XAssignedAirlinePCCVisibility(status: boolean) {
    this.oneGNDC.oneGNDC8K5XRightStatus = status;
  }

  updateIndNDCAssignedAirlinePCCVisibility(status: boolean) {
    this.indNDC.rightStatus = status;
  }
  updateLccsAssignedAirlinePCCVisibility(status: boolean) {
    this.lccs.rightStatus;
  }
  
  userTicketIssueRightsPCCs = new UserTicketIssueRightsPCCs();
  oneG = new OneGprops();
  oneGGDS = new OneGGDSprops();
  oneGNDC = new OneGNDCprops();
  indNDC = new IndNDCprops();
  lccs = new LCCsprops();

  checkAirlineAllIsSelected1G7KE2(): void {
    const allSelected = this.oneG.assignedAirlines1G7KE2.includes('All');
    if (allSelected) {
      this.oneG.assignedAirlines1G7KE2 = ['All'];
    } else {
      this.oneG.assignedAirlines1G7KE2 = this.oneG.assignedAirlines1G7KE2.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelected1G84XH(): void {
    const allSelected = this.oneG.assignedAirlines1G84XH.includes('All');
    if (allSelected) {
      this.oneG.assignedAirlines1G84XH = ['All'];
    } else {
      this.oneG.assignedAirlines1G84XH = this.oneG.assignedAirlines1G84XH.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelected1G8X4I(): void {
    const allSelected = this.oneG.assignedAirlines1G8X4I.includes('All');
    if (allSelected) {
      this.oneG.assignedAirlines1G8X4I = ['All'];
    } else {
      this.oneG.assignedAirlines1G8X4I = this.oneG.assignedAirlines1G8X4I.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelected1GB2D(): void {
    const allSelected = this.oneG.assignedAirlines1GB2D.includes('All');
    if (allSelected) {
      this.oneG.assignedAirlines1GB2D = ['All'];
    } else {
      this.oneG.assignedAirlines1GB2D = this.oneG.assignedAirlines1GB2D.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelected1G82QT(): void {
    const allSelected = this.oneG.assignedAirlines1G82QT.includes('All');
    if (allSelected) {
      this.oneG.assignedAirlines1G82QT = ['All'];
    } else {
      this.oneG.assignedAirlines1G82QT = this.oneG.assignedAirlines1G82QT.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelected1G8K5X(): void {
    const allSelected = this.oneG.assignedAirlines1G8K5X.includes('All');

    if (allSelected) {
      this.oneG.assignedAirlines1G8K5X = ['All'];
    } else {
      this.oneG.assignedAirlines1G8K5X = this.oneG.assignedAirlines1G8K5X.filter(a => a !== 'All');
    }
  }

  checkAirlineAllIsSelectedGDS8X4I(): void {
    const allSelected = this.oneGGDS.assignedAirlinesGDS8X4I.includes('All');
    if (allSelected) {
      this.oneGGDS.assignedAirlinesGDS8X4I = ['All'];
    } else {
      this.oneGGDS.assignedAirlinesGDS8X4I = this.oneGGDS.assignedAirlinesGDS8X4I.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedGDS8K5X(): void {
    const allSelected = this.oneGGDS.assignedAirlinesGDS8K5X.includes('All');
    if (allSelected) {
      this.oneGGDS.assignedAirlinesGDS8K5X = ['All'];
    } else {
      this.oneGGDS.assignedAirlinesGDS8K5X = this.oneGGDS.assignedAirlinesGDS8K5X.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedGDSB2D(): void {
    const allSelected = this.oneGGDS.assignedAirlinesGDSB2D.includes('All');
    if (allSelected) {
      this.oneGGDS.assignedAirlinesGDSB2D = ['All'];
    } else {
      this.oneGGDS.assignedAirlinesGDSB2D = this.oneGGDS.assignedAirlinesGDSB2D.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedGDS7KE2(): void {
    const allSelected = this.oneGGDS.assignedAirlinesGDS7KE2.includes('All');
    if (allSelected) {
      this.oneGGDS.assignedAirlinesGDS7KE2 = ['All'];
    } else {
      this.oneGGDS.assignedAirlinesGDS7KE2 = this.oneGGDS.assignedAirlinesGDS7KE2.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedNDC8X4I(): void {
    const allSelected = this.oneGNDC.assignedAirlinesNDC8X4I.includes('All');
    if (allSelected) {
      this.oneGNDC.assignedAirlinesNDC8X4I = ['All'];
    } else {
      this.oneGNDC.assignedAirlinesNDC8X4I = this.oneGNDC.assignedAirlinesNDC8X4I.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedNDC8K5X(): void {
    const allSelected = this.oneGNDC.assignedAirlinesNDC8K5X.includes('All');
    if (allSelected) {
      this.oneGNDC.assignedAirlinesNDC8K5X = ['All'];
    } else {
      this.oneGNDC.assignedAirlinesNDC8K5X = this.oneGNDC.assignedAirlinesNDC8K5X.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedNDCB2D(): void {
    const allSelected = this.oneGNDC.assignedAirlinesNDCB2D.includes('All');
    if (allSelected) {
      this.oneGNDC.assignedAirlinesNDCB2D = ['All'];
    } else {
      this.oneGNDC.assignedAirlinesNDCB2D = this.oneGNDC.assignedAirlinesNDCB2D.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedNDC7KE2(): void {
    const allSelected = this.oneGNDC.assignedAirlinesNDC7KE2.includes('All');
    if (allSelected) {
      this.oneGNDC.assignedAirlinesNDC7KE2 = ['All'];
    } else {
      this.oneGNDC.assignedAirlinesNDC7KE2 = this.oneGNDC.assignedAirlinesNDC7KE2.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedIndNDC(): void {
    const allSelected = this.indNDC.assignedAirlines.includes('All');
    if (allSelected) {
      this.indNDC.assignedAirlines = ['All'];
    } else {
      this.indNDC.assignedAirlines = this.indNDC.assignedAirlines.filter(a => a !== 'All');
    }
  }
  checkAirlineAllIsSelectedLCCs(): void {
    const allSelected = this.lccs.assignedAirlines.includes('All');
    if (allSelected) {
      this.lccs.assignedAirlines = ['All'];
    } else {
      this.lccs.assignedAirlines = this.lccs.assignedAirlines.filter(a => a !== 'All');
    }
  }
}
